import {combineReducers} from 'redux';
import {sessionInfoExpandAction, sessionInfoSetAction} from 'module/SessionInfo/action/SessionInfoAction';
import {EvoAppsUserInfoTO} from 'generated/JavaTO';
import {createReducer} from 'util/redux';
import {SessionInfoExpandedStateType} from 'module/SessionInfo/type/SessionInfoType';

const dataReducer = createReducer<null | EvoAppsUserInfoTO>(null, builder => builder
	.addCase(sessionInfoSetAction, (state, {payload}) => {
		if (state && !payload) return state; // prevent unsetting data
		if (state && payload && (state.evoAppsUser.username !== payload.evoAppsUser.username || state.evoAppsUser.userGroup.id !== payload.evoAppsUser.userGroup.id)) {
			// session expired and changed user fell back to auth user
			window.location.reload();
		}
		return payload
	}),
)

const expandedReducer = createReducer<SessionInfoExpandedStateType>({
		User: true,
		CostCenter: false,
		Calculation: false,
		PersonalInfo: false,
		Password: true,
	}, builder => builder
		.addCase(sessionInfoExpandAction, (state, {payload}) => ({
			...state,
			[payload.name]: payload.expanded,
		})),
)

export const SessionInfoReducerNS = {
	SessionInfo: combineReducers({
		data: dataReducer,
		expanded: expandedReducer,
	}),
};
export type SessionInfoStateType = { SessionInfo: ReturnType<typeof SessionInfoReducerNS.SessionInfo> };